import { render, staticRenderFns } from "./TableCustomers.vue?vue&type=template&id=1ef3f234&"
import script from "./TableCustomers.vue?vue&type=script&lang=js&"
export * from "./TableCustomers.vue?vue&type=script&lang=js&"
import style0 from "./TableCustomers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports